import { createLineDiscussionsAdapter } from './line_discussions.js?vue3';
import { createNoPreviewDiscussionsAdapter } from './no_preview_discussions.js?vue3';
import { commitDiffDiscussionsStore } from '../stores/instances/commit_discussions.js?vue3';
import { s__ } from '~/locale';

const discussionsErrorMessage = s__(
  'RapidDiffs|Some discussions for this file could not be displayed.',
);

export const commitInlineDiscussionsAdapter = createLineDiscussionsAdapter({
  store: commitDiffDiscussionsStore,
  parallel: false,
  errorMessage: discussionsErrorMessage,
});
export const commitParallelDiscussionsAdapter = createLineDiscussionsAdapter({
  store: commitDiffDiscussionsStore,
  parallel: true,
  errorMessage: discussionsErrorMessage,
});
export const commitNoPreviewDiscussionsAdapter = createNoPreviewDiscussionsAdapter(
  commitDiffDiscussionsStore,
);
